// ─── Modal reutilizable ─────────────────────────────────────────────────────
// Modal simple con backdrop, cerrar por Escape o click fuera, header opcional
// y footer con actions.
//
// Uso:
//   <Modal isOpen={open} onClose={() => setOpen(false)} title="Confirmar envío"
//          actions={
//            <>
//              <button onClick={() => setOpen(false)}>Cancelar</button>
//              <button onClick={handleSend}>Enviar</button>
//            </>
//          }
//          maxWidth={640}>
//     …contenido…
//   </Modal>

import { useEffect } from 'react'

const C = {
  text: '#2C2017', muted: '#7A6A5A', border: '#DDD5C8',
  bg: '#FFFFFF', overlay: 'rgba(59,47,47,0.55)',
}
const FONT = "'DM Sans', sans-serif"

export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  actions,
  maxWidth = 560,
}) {
  useEffect(() => {
    if (!isOpen) return
    function onKey(e) {
      if (e.key === 'Escape') onClose?.()
    }
    document.addEventListener('keydown', onKey)
    const prevOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = prevOverflow
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: C.overlay,
        display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
        padding: '4rem 1rem 2rem', zIndex: 1000, fontFamily: FONT,
        overflowY: 'auto',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: C.bg, borderRadius: 8, width: '100%', maxWidth,
          boxShadow: '0 12px 40px rgba(59,47,47,0.25)',
          display: 'flex', flexDirection: 'column',
          maxHeight: 'calc(100vh - 6rem)',
        }}
      >
        {title && (
          <div style={{
            padding: '1rem 1.25rem', borderBottom: `1px solid ${C.border}`,
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}>
            <div style={{ fontSize: '0.95rem', fontWeight: 600, color: C.text }}>{title}</div>
            <button
              onClick={onClose}
              aria-label="Cerrar"
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: C.muted, fontSize: '1.2rem', lineHeight: 1, padding: '0 0.25rem',
              }}
            >×</button>
          </div>
        )}
        <div style={{ padding: '1.25rem', overflowY: 'auto', flex: 1 }}>
          {children}
        </div>
        {actions && (
          <div style={{
            padding: '0.85rem 1.25rem', borderTop: `1px solid ${C.border}`,
            display: 'flex', justifyContent: 'flex-end', gap: '0.5rem',
          }}>
            {actions}
          </div>
        )}
      </div>
    </div>
  )
}
